<template>
  <div>
    <div class="row mb-5">
      <div class="col-12" style="display: flex; align-items: center">
        <span class="display-4">
          {{ `${establishment.company_name}` }} - {{ $t("COMMON.TRANSFERS") }}
        </span>
        <base-button
          v-if="establishment.active"
          type="primary"
          icon
          size="sm"
          @click="
            () => {
              showAddTransferModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-single-copy-04"></i>
            {{ $t("COMMON.ADD") }}
          </span>
        </base-button>
        <help-button context="establishment-transfers" class="ml-2" />
      </div>
    </div>

    <establishment-transfer-list-table
      ref="transferTable"
      :filterEstablishment="establishment.id"
      :hideAddButton="true"
    />

    <establishment-view-transfers-add-transfer-modal
      :establishment="establishment"
      :showModal="showAddTransferModal"
      @onCloseModal="showAddTransferModal = false"
      @created="refreshTransfers"
    />
  </div>
</template>

<script>
import EstablishmentTransferListTable from "@/views/Pages/InventoryModule/EstablishmentTransferManagement/partials/EstablishmentTransferListTable.vue";
import EstablishmentViewTransfersAddTransferModal from "./EstablishmentViewTransfersAddTransferModal.vue";

export default {
  name: "EstablishmentViewTransfers",
  components: {
    EstablishmentTransferListTable,
    EstablishmentViewTransfersAddTransferModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAddTransferModal: false,
    };
  },
  methods: {
    refreshTransfers() {
      this.$refs.transferTable?.getList();
    },
  },
};
</script>
